import angular from 'angular';
import ComponentsModule from '../components-module';
import template from './code-content-activity.html';
import Debug from 'ace-ui/ace-debug';

const COMPONENT_NAME = 'codeContentActivity';
const debug = new Debug(COMPONENT_NAME, false);

angular.module (ComponentsModule)
  .component (COMPONENT_NAME, {
    template,

    bindings: {
      isDisplayed: '<'
    },

    controller: ($scope, $element, ApplicationConfigurationService, UiState) => {
      let ctrl = $scope.$ctrl;

      ctrl.codeInboxToggle = () => {
        debug.log ('Content Activity toggled');
        ctrl.codeInboxExpanded = !ctrl.codeInboxExpanded;
        ctrl.codeInboxUpdate();
        UiState.set(COMPONENT_NAME, { codeInboxExpanded: ctrl.codeInboxExpanded });
      };

      ctrl.codeWorkflowToggle = () => {
        debug.log ('Workflow toggled');
        ctrl.codeWorkflowExpanded = !ctrl.codeWorkflowExpanded;
        ctrl.codeWorkflowUpdate();
        UiState.set(COMPONENT_NAME, { codeWorkflowExpanded: ctrl.codeWorkflowExpanded });
      };

      // increment == falsy -> reset
      ctrl.codeInboxUpdate = (increment) => {
        debug.log ('Change detected', ctrl.codeInboxExpanded);

        if (increment && !ctrl.codeInboxExpanded) {
          ctrl.codeInboxUpdates += increment;
        } else {
          ctrl.codeInboxUpdates = 0;
        }
      };

      ctrl.codeWorkflowUpdate = (increment) => {
        if (increment && !ctrl.codeWorkflowExpanded) {
          ctrl.codeWorkflowUpdates += increment;
        } else {
          ctrl.codeWorkflowUpdates = 0;
        }
      };

      ctrl.$onInit = () => {
        debug.log ('init');

        ApplicationConfigurationService.getConfigurationsFor(['ContentActivityInbox', 'WorkflowInbox'])
          .then(([aiConfig, wiConfig]) => {
            debug.log ('Read config.', aiConfig, wiConfig);

            aiConfig = Object.assign({ enabled: true }, aiConfig);
            wiConfig = Object.assign({ enabled: true }, wiConfig);

            let numberOfItems = [aiConfig, wiConfig].filter((item) => item.enabled).length;

            ctrl.codeInboxConfiguration = aiConfig;
            ctrl.codeWorkflowConfiguration = wiConfig;
            ctrl.codeInboxEnabled = aiConfig.enabled;
            ctrl.codeInboxUpdates = 0;
            ctrl.codeInboxExpanded = UiState.get(COMPONENT_NAME).codeInboxExpanded;
            ctrl.codeWorkflowEnabled = wiConfig.enabled;
            ctrl.codeWorkflowUpdates = 0;
            ctrl.codeWorkflowExpanded = UiState.get(COMPONENT_NAME).codeWorkflowExpanded;
            ctrl.expandable = numberOfItems > 1;

            if (!ctrl.expandable) {
              ctrl.codeWorkflowExpanded = true;
              ctrl.codeInboxExpanded = true;
            }
          });
      };
    }
  });

export default COMPONENT_NAME;